var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlineCcLogoBlanco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 61.097,
    viewBox: "0 0 260 61.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OutlineCCLogo_Blanco",
    transform: "translate(-336.267 -306.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(336.267 306.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    fill: "#e4e3c2",
    d: "M357.843,306.052c12.714,0,21.457,8.506,21.457,20.687,0,12.24-8.743,20.746-21.457,20.746-12.774,0-21.576-8.535-21.576-20.775C336.267,314.529,345.069,306.052,357.843,306.052Zm.059,30.912c5.661,0,9.424-4.149,9.424-10.225,0-5.987-3.764-10.077-9.424-10.077-5.779,0-9.662,4.09-9.662,10.077C348.24,332.814,352.123,336.964,357.9,336.964Z",
    "data-name": "Path 78",
    transform: "translate(-336.267 -306.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    fill: "#e4e3c2",
    d: "M426.486,307.166h11.47v24.421c0,4.238,3.7,6.372,7.291,6.372,3.823,0,7.32-2.312,7.32-6.372V307.166h11.47v25.251c0,10.788-9.424,15.589-18.79,15.589-10.136,0-18.76-5.186-18.76-15.589Z",
    "data-name": "Path 79",
    transform: "translate(-378.464 -306.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    fill: "#e4e3c2",
    d: "M516.314,316.828h-11.47v-9.662H539.9v9.662H528.139v30.585H516.314Z",
    "data-name": "Path 80",
    transform: "translate(-415.114 -306.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    fill: "#e4e3c2",
    d: "M610.008,347.413H578.86V307.166h11.825v30.822h19.323Z",
    "data-name": "Path 81",
    transform: "translate(-449.733 -306.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    fill: "#e4e3c2",
    d: "M657.461,347.413H645.636V307.166h11.825Z",
    "data-name": "Path 82",
    transform: "translate(-480.965 -306.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    fill: "#e4e3c2",
    d: "M691.225,347.413h-11.5V307.166h9.632L707.7,328.652V307.166h11.5v40.247h-9.217l-18.76-21.25Z",
    "data-name": "Path 83",
    transform: "translate(-496.91 -306.573)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    fill: "#e4e3c2",
    d: "M797.154,347.413H765.769V307.166h31.237v9.484H777.594v5.66H795.05v9.424H777.594v6.253h19.56Z",
    "data-name": "Path 84",
    transform: "translate(-537.154 -306.573)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(338.547 358.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    fill: "#e4e3c2",
    d: "M345.368,405.135a6.288,6.288,0,0,1,2.523.5l-.167,2.039a4.882,4.882,0,0,0-2.128-.472c-1.357,0-2.607.562-2.607,2.08,0,1.465,1.232,2.14,2.594,2.14a3.818,3.818,0,0,0,2.14-.633l.365,2.008a5.774,5.774,0,0,1-3,.694,4.226,4.226,0,0,1-4.543-4.178C340.55,406.522,342.792,405.141,345.368,405.135Z",
    "data-name": "Path 85",
    transform: "translate(-340.55 -405.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    fill: "#e4e3c2",
    d: "M372.794,405.135a4.182,4.182,0,1,1-4.352,4.167A4.059,4.059,0,0,1,372.794,405.135Zm.012,6.235a2.05,2.05,0,1,0-1.949-2.063A1.906,1.906,0,0,0,372.806,411.37Z",
    "data-name": "Path 86",
    transform: "translate(-353.596 -405.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    fill: "#e4e3c2",
    d: "M403.916,411.456l-2.241-2.5v4.519h-2.32v-8.118h1.925l2.756,3.175,2.744-3.175h1.931v8.118h-2.326v-4.513l-2.212,2.492Z",
    "data-name": "Path 87",
    transform: "translate(-368.054 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    fill: "#e4e3c2",
    d: "M431.908,405.359h2.313v4.926a1.487,1.487,0,0,0,2.947,0v-4.926h2.313v5.093c0,2.176-1.9,3.144-3.79,3.144-2.044,0-3.784-1.046-3.784-3.144Z",
    "data-name": "Path 88",
    transform: "translate(-383.28 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    fill: "#e4e3c2",
    d: "M463.433,413.477h-2.319v-8.118h1.943l3.7,4.334v-4.334h2.32v8.118h-1.859l-3.784-4.285Z",
    "data-name": "Path 89",
    transform: "translate(-396.94 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    fill: "#e4e3c2",
    d: "M493.5,413.477h-2.385v-8.118H493.5Z",
    "data-name": "Path 90",
    transform: "translate(-410.973 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    fill: "#e4e3c2",
    d: "M514.355,405.359c2.642,0,4.232,1.37,4.232,4.029s-1.578,4.088-4.232,4.088h-3.712v-8.118Zm1.811,4.029a1.809,1.809,0,0,0-1.949-2.08h-1.225v4.232h1.225C515.479,411.54,516.166,410.722,516.166,409.388Z",
    "data-name": "Path 91",
    transform: "translate(-420.106 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    fill: "#e4e3c2",
    d: "M545.014,412.121h-2.941l-.52,1.356h-2.547l3.121-8.118h2.845l3.114,8.118H545.54Zm-2.4-1.8h1.859l-.926-2.714Z",
    "data-name": "Path 92",
    transform: "translate(-433.372 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    fill: "#e4e3c2",
    d: "M573.99,405.359c2.642,0,4.233,1.37,4.233,4.029s-1.578,4.088-4.233,4.088h-3.712v-8.118Zm1.811,4.029c0-1.416-.741-2.08-1.949-2.08h-1.225v4.232h1.225C575.114,411.54,575.8,410.722,575.8,409.388Z",
    "data-name": "Path 93",
    transform: "translate(-447.999 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    fill: "#e4e3c2",
    d: "M623.2,405.135a6.288,6.288,0,0,1,2.522.5l-.168,2.039a4.877,4.877,0,0,0-2.128-.472c-1.357,0-2.606.562-2.606,2.08,0,1.465,1.231,2.14,2.594,2.14a3.816,3.816,0,0,0,2.14-.633l.365,2.008a5.771,5.771,0,0,1-2.995.694,4.226,4.226,0,0,1-4.543-4.178C618.381,406.522,620.622,405.141,623.2,405.135Z",
    "data-name": "Path 94",
    transform: "translate(-470.497 -405.135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    fill: "#e4e3c2",
    d: "M652,413.477l-1.578-2.205h-1.041v2.205h-2.367v-8.118h4.113a2.874,2.874,0,0,1,3.162,2.924,2.722,2.722,0,0,1-1.471,2.48l2.008,2.714Zm-2.618-6.139v2h1.339c.7,0,1.148-.347,1.148-1,0-.681-.424-.992-1.148-.992Z",
    "data-name": "Path 95",
    transform: "translate(-483.89 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    fill: "#e4e3c2",
    d: "M682.416,413.477h-6.331v-8.118h6.3v1.913H678.47v1.142h3.521v1.9H678.47v1.261h3.946Z",
    "data-name": "Path 96",
    transform: "translate(-497.487 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    fill: "#e4e3c2",
    d: "M707.761,412.121H704.82l-.52,1.356h-2.547l3.121-8.118h2.845l3.114,8.118h-2.546Zm-2.4-1.8h1.859l-.926-2.714Z",
    "data-name": "Path 97",
    transform: "translate(-509.492 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    fill: "#e4e3c2",
    d: "M732.936,407.308h-2.313v-1.949h7.071v1.949h-2.373v6.169h-2.385Z",
    "data-name": "Path 98",
    transform: "translate(-522.995 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    fill: "#e4e3c2",
    d: "M760.585,413.477H758.2v-8.118h2.385Z",
    "data-name": "Path 99",
    transform: "translate(-535.894 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    fill: "#e4e3c2",
    d: "M783.211,405.359h2.625l-2.827,8.118h-3.228l-2.851-8.118h2.624l1.841,5.823Z",
    "data-name": "Path 100",
    transform: "translate(-544.653 -405.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    fill: "#e4e3c2",
    d: "M811.962,412.121h-2.941l-.52,1.356h-2.546l3.12-8.118h2.846l3.114,8.118h-2.547Zm-2.4-1.8h1.859l-.926-2.714Z",
    "data-name": "Path 101",
    transform: "translate(-558.23 -405.24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineCcLogoBlanco);
export default __webpack_public_path__ + "static/media/OutlineCCLogo_Blanco.52bbb745c7058c475160943477fd1b74.svg";
export { ForwardRef as ReactComponent };